import { LitElement, html, unsafeCSS, css } from 'lit'
import { customElement, property, state } from 'lit/decorators.js'
import { installOfflineWatcher } from 'pwa-helpers/network.js';
import { installRouter } from 'pwa-helpers/router.js';
import { connect } from 'pwa-helpers/connect-mixin.js';
import rgbHex from "rgb-hex";
import { appStore, setOffline, setPage, setPageGroup, setPayload } from './slice/appSlice';
import { COMMAND_GET_GATEWAY_DETAILS, COMMAND_GET_INSTITUTION_DETAILS, COMMAND_GET_INTERFACE, COMMAND_GET_SECTION, Response } from './core/parsers/response';
import './themes/dsv4.0/templates/canvas-page'
import './themes/dsv4.0/templates/landing-page'
import './themes/dsv4.0/templates/service-page'
import './themes/dsv4.0/templates/payments-page'

// Import processed Tailwind CSS
import tailwindCSS from './index.css?inline'
import {gateway_colors} from '../colors';
// import materialDynamicColors from 'material-dynamic-colors';
// import rgbHex from 'rgb-hex';

// Extend Window interface to include custom properties
declare global {
  interface Window {
    TEMPLATE?: string;
    csrfToken?: string;
    gateway?: string;
  }
}

@customElement('my-element')
export class MyElement extends connect(appStore)(LitElement) {
  [x: string]: any;
  @property({ type: String })
  docsHint = 'Click on the Vite and Lit logos to learn more'

  @property({ type: Number })
  count = 0

  @property({ type: String })
  payloadjson = ''

  @property({ type: String })
  template = ''

  @property({ type: String })
  appTitle = ''

  @property({ type: String })
  csrfToken = ''

  @state()
  private isLoading = false

  @state()
  private interfaceData: any = null

  @state()
  private currentPageGroup: any = null

  @state()
  private themeMode: 'light' | 'dark' = 'light';

  @state()
  private gatewayData: any = null;

  @state()
  private interface: any = null;

  @state()
  private pageGroup: any = null;

  // Add missing defaultColors property
  private defaultColors = {
    light: {
      primary: '#6750A4',
      secondary: '#625B71',
    },
    dark: {
      primary: '#D0BCFF',
      secondary: '#CCC2DC',
    }
  };

  firstUpdated() {
      // FIX: Use window.TEMPLATE with proper null check
      this.template = window.TEMPLATE || 'landing'; // Provide default value
    
    try {
      const parsedPayload = JSON.parse(this.payloadjson);
      appStore.dispatch(setPayload(parsedPayload));
    } catch (err) {
      console.error('Failed to parse payloadjson:', err);
    }

    // Get interface data and store it
    this.interfaceData = this.interfaceSelector(this.payloadjson);
    
    this.gatewayData = this.gatewaySelector(this.payloadjson);
    this.logo = this.gatewayData._response?.logo
    if(this.gatewayData?._response?.sdk_available){
    this.injectGlobalChatboxScript(this.gatewayData._response?.sdk_link);
    }

        // Inject CyberSource script if available
    if(this.gatewayData?._response?.cybersource_link) {
        this.injectCyberSourceScript(this.gatewayData._response?.cybersource_link);
    }

    if (this.appTitle) {
      document.title = this.appTitle;
    }
    
    if (this.csrfToken) {
      window.csrfToken = this.csrfToken;
    }

const default_color = this.gatewayData._response.default_color;
const isRgbFormat = default_color.startsWith("rgb");
let hexColor = "";
let rgbColor = "";

if (isRgbFormat) {
    hexColor = rgbHex(default_color); // Convert RGB to HEX
    hexColor = `#${hexColor}`; // Add # if needed
    
    // Extract RGB values from the RGB string
    const rgbMatch = default_color.match(/rgb\((\d+),\s*(\d+),\s*(\d+)\)/);
    if (rgbMatch) {
        rgbColor = `${rgbMatch[1]}, ${rgbMatch[2]}, ${rgbMatch[3]}`;
    }
} else {
    hexColor = default_color; // Assume already HEX
    
    // Convert HEX to RGB
    hexColor = hexColor.replace('#', '');
    const r = parseInt(hexColor.substring(0, 2), 16);
    const g = parseInt(hexColor.substring(2, 4), 16);
    const b = parseInt(hexColor.substring(4, 6), 16);
    rgbColor = `${r}, ${g}, ${b}`;
    hexColor = `#${hexColor}`; // Ensure # prefix
}

// Set both HEX and RGB variables
document.documentElement.style.setProperty('--md-sys-color-primary-hex', hexColor);
document.documentElement.style.setProperty('--md-sys-color-primary-rgb', rgbColor);



    installRouter((location: Location) =>
      this.setupRouting(window.decodeURIComponent(location.pathname))
    );

    installOfflineWatcher((offline: boolean) =>
      appStore.dispatch(setOffline(offline))
    );
    this._initTheme();
    this.loadTemplate();
  }

  stateChanged(state: { app: { pageGroup: any; page: any;  payload: any; offline: any; }; }) {
    if(state.app) {

      this.interface = this.interfaceSelector(state.app.payload);
      
      this.gateway = this.gatewaySelector(state.app.payload);
      this.pageGroup = this.currentPageGroupSelector(state.app.pageGroup);
      this.page = this.currentPageSelector(state.app.page);
    }
  }

  connectedCallback() {
  super.connectedCallback();
  // Listen for theme changes from ServicePage
  // @ts-ignore
  window.addEventListener('theme-changed', this._handleThemeChange.bind(this));
}

disconnectedCallback() {
  super.disconnectedCallback();
  // @ts-ignore
  window.removeEventListener('theme-changed', this._handleThemeChange.bind(this));
}


  private injectGlobalChatboxScript(srcLink: string) {
    // Check if we're in a browser environment
    if (typeof window === 'undefined' || typeof document === 'undefined') {
      console.error('This function can only run in a browser environment');
      return false;
    }
    
    // Check if the script is already injected to avoid duplicates
    const existingScript = document.querySelector('script[src="' + srcLink + '"]');
    
    // Create and inject the module script if it doesn't exist
    if (!existingScript) {
      const scriptElement = document.createElement('script');
      scriptElement.type = 'module';
      scriptElement.src = srcLink;
      
      // Add error handling for the script
      scriptElement.onerror = function() {
        console.error('Failed to load SDK script');
      };
      
      
      // Inject the script at the end of the body
      document.body.appendChild(scriptElement);
    } 
    
    return true;
  }

  private injectCyberSourceScript(srcLink: string) {
    
    // Check if we're in a browser environment
    if (typeof window === 'undefined' || typeof document === 'undefined') {
      console.error('This function can only run in a browser environment');
      return false;
    }
    
    // Check if the script is already injected to avoid duplicates
    const existingScript = document.querySelector('script[src="' + srcLink + '"]');
    
    // Create and inject the script if it doesn't exist
    if (!existingScript) {
      const scriptElement = document.createElement('script');
      scriptElement.src = srcLink;
      
      // Determine script type based on file extension or content
      if (srcLink.endsWith('.mjs') || srcLink.includes('module')) {
        scriptElement.type = 'module';
      }
      
      // Add error handling for the script
      scriptElement.onerror = function() {
        console.error('Failed to load CyberSource script');
      };
      
      scriptElement.onload = function() {
        console.log('CyberSource script loaded successfully');
      };
      
      // Inject the script at the end of the body
      document.body.appendChild(scriptElement);
    } else {
      console.log('CyberSource script already exists');
    }
    
    return true;
}

private _handleThemeChange(event: CustomEvent) {
  const newTheme = event.detail.theme as 'light' | 'dark';
  const darkMode = event.detail.darkMode;

  if (newTheme === this.themeMode) return; // no-op

  this.themeMode = newTheme;

  // ✅ Same key everywhere
  localStorage.setItem('dark_mode', newTheme);

  this._applyRootThemeClass();
  this._applyMaterialTheme();
  this._applyRootVariables();

  this.dispatchEvent(new CustomEvent('theme-updated', {
    detail: { theme: newTheme, darkMode },
    bubbles: true,
    composed: true
  }));

  this.requestUpdate();
}

  currentPageGroupSelector(pageGroupTitle: string) {
    return this.interface?.pageGroups?.find((group: { _title: string; }) => {
      const normalizedTitle = group._title.toLowerCase().replace(/\s+/g, '-');
      return normalizedTitle === pageGroupTitle;
    }) || null;
  }

  currentPageSelector(pageTitle: string) {
    if (!this.pageGroup) return null;

    return this.pageGroup.pages.find((page: any) => {
      const normalizedTitle = page.title.toLowerCase().replace(/\s+/g, '-');
      return normalizedTitle === pageTitle;
    }) || null;
  }

  private setupRouting(_path: string) {
    if (!window.location.hash) {
      if (this.interfaceData && this.interfaceData._pageGroups && this.interfaceData._pageGroups.length > 0) {
        const firstPageGroup = this.interfaceData._pageGroups[0];
        const firstPage = firstPageGroup._tabs?.[0]?._title || '0';

        // Format: lowercase and replace spaces with hyphens
        const groupSlug = firstPageGroup._title?.toLowerCase().replace(/\s+/g, '-') || '0';
        const pageSlug = firstPage.toLowerCase().replace(/\s+/g, '-');

        window.location.href += `#/${groupSlug}/${pageSlug}`;
      }
    }

    // const paths = path.split('/').filter(Boolean);
    const hashParts = window.location.hash.split('/');
    const pageGroupSlug = hashParts[1] || '0';
    const pageSlug = hashParts[2] || '0';

    // Find the current page group based on the slug
    this.setCurrentPageGroup(pageGroupSlug);

    appStore.dispatch(setPageGroup(pageGroupSlug));
    appStore.dispatch(setPage(pageSlug));

    // if (paths.length > 1) {
    //   appStore.dispatch(setView('dialog'));
    // }
  }

  private setCurrentPageGroup(pageGroupSlug: string) {
    if (!this.interfaceData?._pageGroups) return;

    // Convert slug back to title format (hyphens to spaces, capitalize)
    const pageGroupTitle = pageGroupSlug.replace(/-/g, ' ').replace(/\b\w/g, l => l.toUpperCase());
    
    // Find the page group by title
    const pageGroup = this.interfaceData._pageGroups.find((group: any) => 
      group._title?.toLowerCase().replace(/\s+/g, '-') === pageGroupSlug ||
      group._title === pageGroupTitle
    );

    if (pageGroup) {
      this.currentPageGroup = {
        title: pageGroup._title,
        slug: pageGroupSlug,
        pages: pageGroup.pages
      };
      
    } else {
      // Fallback to first page group if not found
      const firstPageGroup = this.interfaceData._pageGroups[0];
      
      this.currentPageGroup = {
        title: firstPageGroup._title,
        slug: firstPageGroup._title?.toLowerCase().replace(/\s+/g, '-'),
        pages: firstPageGroup._tabs?.map((tab: any, index: number) => ({
          id: `page-${index + 1}`,
          title: tab._title,
          slug: tab._title?.toLowerCase().replace(/\s+/g, '-'),
          pageInputGroups: tab._inputs || []
        })) || []
      };
    }

    // Reload template with updated page group data
    this.loadTemplate();
  }

  private interfaceSelector(payload: any) {
    const parsedResponse = this.parsePayload(payload);

    return parsedResponse.serviceCommands[COMMAND_GET_INTERFACE] || 
           parsedResponse.serviceCommands[COMMAND_GET_SECTION];
  }

  private gatewaySelector(payload: any){
    // FIX: Add null checks
    const value = this.parsePayload(payload).serviceCommands[COMMAND_GET_GATEWAY_DETAILS] || 
                  this.parsePayload(payload).serviceCommands[COMMAND_GET_INSTITUTION_DETAILS]; 
    
    if (value?._response?.name) {
      localStorage.setItem('gateway_name', value._response.name);
    }
  
    return value;
  };

  private parsePayload(payload: any) {
    const response = new Response(payload);
    response.parseAll({});

    return response;
  }

async _initTheme() {
  // ✅ Read the same key ServicePage writes to
  const saved = (localStorage.getItem('dark_mode') as 'light' | 'dark') || 'light';
  this.themeMode = saved;

  // Apply immediately so first paint is correct
  this._applyRootThemeClass();
  await this._applyMaterialTheme();
  this._applyRootVariables();
}

private _applyRootThemeClass() {
  if (this.themeMode === 'dark') {
    document.documentElement.classList.add('dark');
  } else {
    document.documentElement.classList.remove('dark');
  }
}

  async _applyMaterialTheme() {
    let colors: any;

    // FIX: Add null checks
    const gatewayName = String(this.gatewayData?._response?.name?.toLowerCase() || 'default');
    // Use type assertion to tell TypeScript it's safe
    const gatewayColors = gateway_colors as { [key: string]: any };
    const matchedColorObject = gatewayColors[0][gatewayName];
    if(this.gatewayData?._response?.color_theme){
      colors = this.gatewayData._response.color_theme;
    }
    else if (matchedColorObject) {
      colors = matchedColorObject;
    } else {
      colors = gatewayColors[0]['default'];
    }

    const current = colors[this.themeMode === 'dark' ? 'dark' : 'light'] || 
                   (this.themeMode === 'dark' ? this.defaultColors.dark : this.defaultColors.light);
    
    this._applyColorVariables(current);
  }

  private _applyColorVariables(colors: any) {
    const root = document.documentElement;
    
    // Apply all color variables
    Object.entries(colors).forEach(([key, value]) => {
      const v = value == null ? null : String(value);
      root.style.setProperty(`--md-sys-color-${key}`, v);
    });

    // Also set key colors for convenience
    root.style.setProperty('--primary', String(colors.primary));
    root.style.setProperty('--secondary', String(colors.secondary));
  }

  private _applyRootVariables() {
    const root = document.documentElement;

    root.style.setProperty('--font-family', 'Poppins');
    root.style.setProperty('--theme-mode', this.themeMode);

    // Set text color based on theme
    const textColor = this.themeMode === 'dark' ? 'white' : 'black';
    root.style.setProperty('--text-color', textColor);
    root.style.setProperty('--primary-text', textColor);
  }

  dialogView(...args: any[]) {
    const pageElement = this.shadowRoot?.querySelector(`${this.template}-page`) as any;
    if (pageElement && pageElement._activateLoadSectionInterface) {
      pageElement._activateLoadSectionInterface(...args)
        .then((_r: any) => {
          
        })
        .catch((error: any) => {
          console.error(error);
        });
    }
  }

  private async loadTemplate() {
    try {   
      const templateHolder = this.shadowRoot?.querySelector('.template');
      if (templateHolder && this.template) {
        templateHolder.innerHTML = '';
        const newElement = document.createElement(`${this.template}-page`);
        // Pass both interfaceData and pageGroup as properties to the template page
        (newElement as any).interfaceData = this.interfaceData;
        (newElement as any).pageGroup = this.currentPageGroup;
        (newElement as any).logo = this.logo;
        (newElement as any).gateway = this.gatewayData._response;

        window.gateway = this.gatewayData._response.name; // Set global gateway variable

        
        
        templateHolder.appendChild(newElement);
      }
    } catch (error) {
      console.error('Error loading template:', error);
    }
    return
  }

  render() {
    // Show loader when isLoading is true
    if (this.isLoading) {
      return this.renderLoader();
    }

    return this.renderContent();
  }

  private renderLoader() {
    return html`
      <div class="fixed inset-0 bg-white dark:bg-gray-900 flex items-center justify-center z-50">
        <div class="text-center">
          <div class="loader mb-4"></div>
          <p class="text-gray-600 dark:text-gray-400 text-lg font-medium">Loading...</p>
        </div>
      </div>
    `;
  }

  private renderContent() {
    return html`
      <div class="template">
        
        
        <slot></slot>
        
        <div class="flex items-center justify-center h-full min-h-screen bg-gradient-to-br from-slate-50 to-gray-100">
  <div class="text-center p-8 max-w-md">
    <!-- Animated Icon -->
    <div class="relative mb-6">
      <div class="w-20 h-20 mx-auto bg-gradient-to-r from-rose-400 to-pink-500 rounded-2xl flex items-center justify-center shadow-lg shadow-pink-500/25 rotate-45 transform-gpu">
        <svg class="w-10 h-10 text-white -rotate-45" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"/>
        </svg>
      </div>
      <div class="absolute -inset-2 bg-rose-500/10 rounded-3xl blur-sm animate-pulse"></div>
    </div>

    <!-- Text Content -->
    <h2 class="text-2xl font-bold text-gray-900 mb-3 bg-gradient-to-r from-gray-900 to-gray-700 bg-clip-text text-transparent">
      Content Unavailable
    </h2>
    
    <p class="text-gray-600 mb-6 leading-relaxed">
      We couldn't load the interface data at this moment. This might be temporary - please try refreshing the page.
    </p>

    <!-- Action Button -->
    <button 
  onclick="window.location.href = '/';"
  class="group relative inline-flex items-center px-6 py-3 bg-gradient-to-r from-slate-900 to-gray-800 text-white font-medium rounded-xl hover:from-gray-800 hover:to-slate-900 transition-all duration-300 shadow-lg hover:shadow-xl hover:scale-105 transform-gpu"
>
  <svg class="w-5 h-5 mr-2 group-hover:rotate-180 transition-transform duration-300" fill="none" stroke="currentColor" viewBox="0 0 24 24">
    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6"/>
  </svg>
  Go to Homepage
  <div class="absolute inset-0 rounded-xl bg-gradient-to-r from-white/10 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
</button>

    <!-- Decorative Elements -->
    <div class="mt-8 flex justify-center space-x-2">
      <div class="w-2 h-2 bg-gray-300 rounded-full animate-bounce" style="animation-delay: 0.1s"></div>
      <div class="w-2 h-2 bg-gray-400 rounded-full animate-bounce" style="animation-delay: 0.2s"></div>
      <div class="w-2 h-2 bg-gray-500 rounded-full animate-bounce" style="animation-delay: 0.3s"></div>
    </div>
  </div>
</div>

      </div>
    `;
  }

  // private _onClick() {
  //   this.count++;
  // }

  // private _toggleLoader() {
  //   this.isLoading = !this.isLoading;
    
  //   // Auto-hide loader after 2 seconds if showing
  //   if (this.isLoading) {
  //     setTimeout(() => {
  //       this.isLoading = false;
  //     }, 2000);
  //   }
  // }

  // Inject Tailwind CSS
  static styles = [unsafeCSS(tailwindCSS), css`
    :host {
      display: flex;
      width: 100vw;
      height: 100vh;
      overflow-x: hidden;
      overflow-y: hidden;
      justify-content: center;
      align-items: center;
    }

    .loader {
      width: 48px;
      height: 48px;
      border-radius: 50%;
      display: inline-block;
      position: relative;
      border: 3px solid;
      border-color: #FFF #FFF transparent;
      box-sizing: border-box;
      animation: rotation 1s linear infinite;
    }
    
    .loader::after {
      content: '';  
      box-sizing: border-box;
      position: absolute;
      left: 0;
      right: 0;
      top: 0;
      bottom: 0;
      margin: auto;
      border: 3px solid;
      border-color: transparent #FF3D00 #FF3D00;
      width: 24px;
      height: 24px;
      border-radius: 50%;
      animation: rotationBack 0.5s linear infinite;
      transform-origin: center center;
    }

    @keyframes rotation {
      0% {
        transform: rotate(0deg);
      }
      100% {
        transform: rotate(360deg);
      }
    } 
        
    @keyframes rotationBack {
      0% {
        transform: rotate(0deg);
      }
      100% {
        transform: rotate(-360deg);
      }
    }
    
    .template {
      width: 100vw;
    }
  `];
}
